/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum UpdateType {
    Resize = 0,
    Move = 1,
    BringForward = 2,
}
